// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1_MGE","cls2":"PaperImages-cls2__2a PaperImages-cls1_MGE"};